import React from "react";
import { Box, Skeleton, Button } from "@mui/material";

const AudioDetailLoading = () => {
  const skeletonStyles = {
    backgroundColor: "white",
    color: "white", // Set the text color to white
  };
  return (
    <Box className="w-full flex gap-2">
      <Skeleton
        variant="rectangular"
        className="rounded-lg"
        width={116.6}
        height={155.6}
        sx={{ ...skeletonStyles }}
      />
      <Box className="w-2/3 inline-block">
        <Skeleton
          variant="text"
          width="80%"
          height={25}
          mb={1}
          sx={{ ...skeletonStyles }}
        />
        <Skeleton
          variant="text"
          width="60%"
          height={25}
          mb={1}
          sx={{ ...skeletonStyles }} 
        />
        <Skeleton
          variant="text"
          width="70%"
          height={25}
          mb={1}
          sx={{ ...skeletonStyles }}
        />
        <Skeleton
          variant="text"
          width="50%"
          height={25}
          mb={1}
          sx={{ ...skeletonStyles }}
        />
        <Box className="w-full mt-5">
          <Skeleton
            size="small"
            variant="contained"
            disabled
            sx={{
              ...skeletonStyles,
              width: "fit-content",
              paddingTop: "5px",
              paddingBottom: "5px",
              paddingRight: "10px",
              paddingLeft: "10px",
              borderTopLeftRadius: "50px",
              borderBottomLeftRadius: "50px",
              borderTopRightRadius: "50px",
              borderBottomRightRadius: "50px",
            //   backgroundColor: "#ca8a04",
            }}
          >
            နားထောင်မည်
          </Skeleton>
        </Box>
      </Box>
    </Box>
  );
};

export default AudioDetailLoading;
